<main cdkVirtualScrollingElement>
  <header>
    <div class="search-wrapper">
      <div class="search-bar-wrapper">
        <div class="search-bar">
          <input
            type="text"
            class="form-control"
            placeholder="Search"
            [(ngModel)]="keyword"
            (ngModelChange)="filterMatchingTenants()"
          />
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
        <button
          type="button"
          class="btn btn-primary"
          (click)="goToNewDeploymentPage()"
        >
          New Deployment
        </button>
      </div>

      <div class="tenants-filter-options">
        <!-- Filter Tenants by License status -->
        <div class="dropdown">
          <label for="licenseStatus">License Status</label>
          <button
            type="button"
            class="form-control dropdown-toggle"
            id="licenseStatus"
            data-bs-toggle="dropdown"
          >
            {{ licenseStatusOption ?? "Any" }}
          </button>
          <ul class="dropdown-menu w-100">
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="!licenseStatusOption"
                (click)="licenseStatusOption = undefined"
              >
                Any
              </button>
            </li>
            @for (licenseStatus of AVAILABLE_LICENSE_STATUS; track $index) {
              <li>
                <button
                  type="button"
                  class="dropdown-item"
                  [class.selected]="licenseStatusOption === licenseStatus"
                  (click)="licenseStatusOption = licenseStatus"
                >
                  {{ licenseStatus }}
                </button>
              </li>
            }
          </ul>
        </div>

        <!-- Filter Tenants by its machines runtime status -->
        <div class="d-flex">
          <div
            class="filter-button"
            [ngClass]="{
              'filter-button-light': tenantsFilterOption !== 'online',
            }"
          >
            <label class="filter-label" for="online-tenants">
              <input
                type="radio"
                id="online-tenants"
                [(ngModel)]="tenantsFilterOption"
                value="online"
                hidden
              />
              Online Tenants
            </label>
          </div>

          <div
            class="filter-button"
            [ngClass]="{
              'filter-button-light': tenantsFilterOption !== 'offline',
            }"
          >
            <label class="filter-label" for="offline-tenants">
              <input
                type="radio"
                id="offline-tenants"
                [(ngModel)]="tenantsFilterOption"
                value="offline"
                hidden
              />
              Offline Tenants
            </label>
          </div>

          <div
            class="filter-button"
            [ngClass]="{ 'filter-button-light': tenantsFilterOption !== 'all' }"
          >
            <label class="filter-label" for="all-tenants">
              <input
                type="radio"
                id="all-tenants"
                [(ngModel)]="tenantsFilterOption"
                value="all"
                hidden
              />
              All
            </label>
          </div>
        </div>
      </div>
    </div>

    <oaibox-deployments-kpis></oaibox-deployments-kpis>
  </header>

  @if (shownTenants.length > 0) {
    <cdk-virtual-scroll-viewport
      minBufferPx="140"
      maxBufferPx="300"
      itemSize="140"
      class="virtual-scroll"
    >
      <ul class="virtual-scroll-content">
        <li *cdkVirtualFor="let tenant of shownTenants; let last = last">
          @if (last) {
            <oaibox-client-row [tenant]="tenant"></oaibox-client-row>
          } @else {
            <oaibox-client-row [tenant]="tenant"></oaibox-client-row>
          }
        </li>
      </ul>
    </cdk-virtual-scroll-viewport>
  } @else {
    <div class="empty-list">
      <strong class="text-muted fs-5">No Tenants</strong>
    </div>
  }
</main>
